<div class="pcheck-card meeting-picker">
  <div class="pcheck-card__header">
    <i class="pi pi-calendar" aria-hidden="true"></i>
    <span>{{ heading }}</span>
  </div>
  <div class="pcheck-card__body">

    <div class="meeting-picker__tz">
      <span class="meeting-picker__tz-label">Times shown in</span>
      <app-timezone-select
        [value]="displayTz()"
        [disabled]="disabled || lockTimezone"
        [compact]="true"
        (valueChange)="onTimezoneChange($event)">
      </app-timezone-select>
    </div>

    <ul class="meeting-picker__list">
      @for (m of meetings; track m.cp_meeting_id || $index) {
        <li>
          <button
            type="button"
            class="meeting-picker__item"
            [disabled]="disabled"
            (click)="onPick(m)">
            <span class="meeting-picker__time">{{ formatTime(m.start_time) }}</span>
            <span class="meeting-picker__meta">
              {{ m.executive }}@if (m.account_name) { · {{ m.account_name }} }
            </span>
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </li>
      }
    </ul>

  </div>
</div>
